import FilterDashboards from './FilterDashboards';

export default FilterDashboards;
